import { InputWrapper, Label } from './Input'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { useDropzone } from 'react-dropzone'
import { ColorVariant, Flex, Icon } from 'styling/GlobalStyles'
import { UploadIcon } from 'assets/icons/UploadIcon'
import { MediumText, SmallText } from 'styling/TypographyV2'

export const FileInput = ({
  label,
  name,
  smallText,
  text,
  uploadFile,
  multiple,
  value,
}: React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string
  smallText?: string
  text?: string
  uploadFile?: (file: File[]) => void
  multiple?: boolean
  value?: File | null
}) => {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    uploadFile?.(acceptedFiles)
  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple })

  return (
    <InputWrapper>
      {label && <Label htmlFor={name}>{label}</Label>}
      <StyledFileInput {...getRootProps()}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <Flex center column gap='0.5rem'>
            <MediumText colorVariant={ColorVariant.SECONDARY}>{UploadIcon}</MediumText>
            <MediumText colorVariant={ColorVariant.SECONDARY}>
              Drop the files here {label}{' '}
            </MediumText>
            <SmallText colorVariant={ColorVariant.SECONDARY}>PNG, JPG up to 10MB</SmallText>
          </Flex>
        ) : (
          <Flex center column gap='0.5rem' justcenter>
            <MediumText colorVariant={ColorVariant.SECONDARY}>{UploadIcon}</MediumText>
            <MediumText colorVariant={ColorVariant.SECONDARY}>
              {text || 'Click to upload or drag and drop'}
            </MediumText>
            {smallText && (
              <SmallText colorVariant={ColorVariant.SECONDARY}>PNG, JPG up to 10MB</SmallText>
            )}
          </Flex>
        )}
      </StyledFileInput>
    </InputWrapper>
  )
}

const StyledFileInput = styled.div`
  width: 100%;
  height: 120px !important;
  border: 1px solid ${(props) => props.theme.tableRowBorder};
  border-radius: 12px;
  padding: 0.75rem 1rem;
  color: ${(props) => props.theme.textColor};
  outline: none;
  background: #22202080;
  display: flex;
  align-items: center;
  justify-content: center;
`
